/** @flow */
import React from "react";
import { View } from "@components";

type TextFieldProps = {
  className?: string,
  format?: string,
  readonly?: boolean,
  type?: string,
  materialIcon?: string | React$Node,
  minLength?: number,
  onChange?: Function,
  onKeyDown?: Function,
  onKeyUp?: Function,
  onSubmit?: Function,
  ...HTMLInputElement,
};

const TextField = (props: TextFieldProps) => {
  const {
    id,
    name,
    autocomplete,
    disabled,
    dirname,
    height,
    max,
    maxLength,
    min,
    minLength,
    placeholder,
    readonly,
    required,
    type,
    value,
    width,
    onChange,
    onKeyDown,
    onKeyUp,
    onSubmit,
  } = { ...props };

  return (
    <View direction="row" height={height} width={width} position={props.materialIcon && "relative"}>
      <input
        id={id}
        name={name}
        autoComplete={autocomplete}
        disabled={disabled}
        max={max}
        maxLength={maxLength}
        min={min}
        minLength={minLength}
        placeholder={placeholder}
        readOnly={readonly}
        required={required}
        value={value}
        type={type || "text"}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        onSubmit={onSubmit}
        className={`form-control ${props.className || ""}`}
      />
      {typeof props.materialIcon === "string" && (
        <View className="material-icons">{props.materialIcon}</View>
      )}
      {typeof props.materialIcon === "object" && props.materialIcon}
    </View>
  );
};

export default TextField;
